import React, { FC } from 'react';
import styled from 'styled-components';
import { appLogoFull, appLogoSimple, appName } from 'src';

const StyledImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;

export type LogoProps = {
  id?: string;
  onClick?: () => void;
  size?: 'small' | 'normal' | 'large';
  className?: string;
  variant?: 'full' | 'simple';
};

const StyledLogo = styled<FC<LogoProps>>(({ size, onClick, ...props }) => (
  <div {...props} onClick={onClick} />
))`
  margin-right: 10px;
  width: ${({ size }) => {
    switch (size) {
      case 'large':
        return '18rem';
      case 'small':
        return '10rem';
      default:
        return '13rem';
    }
  }};
  /*
  TODO: validate later
  height: ${({ size }) => {
    switch (size) {
      case 'large':
        return '11rem';
      case 'small':
        return '3rem';
      default:
        return '7rem';
    }
  }};*/
  cursor: ${({ onClick }) => (!!onClick ? 'pointer' : 'normal')};
`;

const Logo: FC<LogoProps> = ({ id, onClick, variant = 'simple', size, className }) => (
  <StyledLogo id={id} size={size} onClick={onClick} className={className}>
    <StyledImage src={variant === 'full' ? appLogoFull : appLogoSimple} alt={appName} />
  </StyledLogo>
);

export default Logo;
